import HTTP_REQUEST from "../../utils/http";
import * as domicilioTypes from "../types/domiclio";
import url from "../../utils/url";
import { formatToSelectCustom } from "../../utils/Utils";
import { API_CANAL } from '../../utils/consts';
import { changeGlobalState } from "./global";
import helpers from "../../utils/helpers";

export const selectDomicilio = payload => dispatch => {
	dispatch({
		type: domicilioTypes.SELECT_DOMICILIO,
		payload
	})
}

export const errorAPI = (error) => ({
  type: domicilioTypes.DOMICILIO_ERROR_API,
  error: { message: error.message, stack: error.stack },
});

export const loadingDepartamento = () => ({
  type: domicilioTypes.LOADING_DEPARTAMENTO,
});

export const successGetDepartamentos = (payload) => ({
  type: domicilioTypes.DEPARTAMENTOS,
  payload,
});

export const getDespartamentos = (data) => async (dispatch) => {
  dispatch(loadingDepartamento());  
  try {
    const { response: { payload, status } } = await HTTP_REQUEST.postWitchTrace(
      url.obtenerDepartamentos,
      data,
	    'UTILITARIOS',
	    API_CANAL
    );
    const newOrder = payload.filter(({ descripcionDepartamento }) => descripcionDepartamento !== 'LIMA');
    const lima = payload.find(({ descripcionDepartamento }) => descripcionDepartamento === 'LIMA');

    const departamentoFormated = formatToSelectCustom([lima, ...newOrder], {
      value: "ideDepartamento",
	    text: "descripcionDepartamento",
      label: "descripcionDepartamento",
    });
    dispatch(successGetDepartamentos(departamentoFormated));
    return status;
  } catch (error) {
    dispatch(changeGlobalState(4));
    helpers.sendTagError(error, url.obtenerDepartamentos);
  }
};

export const loadingProvincia = () => ({
  type: domicilioTypes.LOADING_PROVINCIA,
});

export const successGetProvincias = (payload) => ({
  type: domicilioTypes.PROVINCIAS,
  payload,
});

export const getProvincias = (data) => async (dispatch) => {
  dispatch(loadingProvincia());
  try {
    const { response: { payload, status } } = await HTTP_REQUEST.postWitchTrace(
    	url.obtenerProvincias,
	    data,
	    'UTILITARIOS',
	    API_CANAL
    );

	  const newOrder = payload.filter(({ descripcionProvincia }) => descripcionProvincia !== 'LIMA');
	  const lima = payload.find(({ descripcionProvincia }) => descripcionProvincia === 'LIMA');
	  let firstLima = newOrder;

	  if (lima) {
		  firstLima = [lima, ...newOrder]
	  }

    const provinciasFormated = formatToSelectCustom(firstLima, {
	    value: "ideProvincia",
	    text: "descripcionProvincia",
      label: "descripcionProvincia",
    });
    
    dispatch(successGetProvincias(provinciasFormated));

    return status;
  } catch (error) {
    dispatch(changeGlobalState(4));
    helpers.sendTagError(error, url.obtenerProvincias);
  }
};

export const loadingDistrito = () => ({
  type: domicilioTypes.LOADING_DISTRITO,
});

export const successGetDistritos = (payload) => ({
  type: domicilioTypes.DISTRITOS,
  payload,
});

export const cleanDomicilio = () => ({
	type: domicilioTypes.CLEAN_DOMICILIO,
});

export const cleanUbigeo = () => ({
  type: domicilioTypes.CLEAN_UBIGEO,
});

export const getDistritos = (data) => async (dispatch) => {
  dispatch(loadingDistrito());
  try {
    const { response: { payload, status } } = await HTTP_REQUEST.postWitchTrace(
    	url.obtenerDistritos,
	    data,
	    'UTILITARIOS',
	    API_CANAL
    );

	  const newOrder = payload.filter(({ descripcionDistrito }) => descripcionDistrito !== 'LIMA');
	  const lima = payload.find(({ descripcionDistrito }) => descripcionDistrito === 'LIMA');
	  let firstLima = newOrder;

	  if (lima) {
		  firstLima = [lima, ...newOrder]
	  }

    const departamentoFormated = formatToSelectCustom(firstLima, {
	    value: "ideDistrito",
	    text: "descripcionDistrito",
      label: "descripcionDistrito",
    });

    dispatch(successGetDistritos(departamentoFormated));

    return status;
  } catch (error) {
    dispatch(changeGlobalState(4));
    helpers.sendTagError(error, url.obtenerDistritos);
  }
};
